import {
  LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, ReferenceLine,
  BarChart, Bar
} from "recharts";
import * as Sentry from "@sentry/react";
import { useInsightsV4 } from "../../hooks/useInsightsV4";

function ResumenInsightsInner() {
  const userId = (typeof window !== "undefined" && window.__USER_ID__) || "guest";
  const { data, loading } = useInsightsV4(userId);

  if (loading) {
    return (
      <div className="insights-panel">
        <h2 className="insights-title">Predicción avanzada (Transformers)</h2>
        <p className="insights-subtitle">
          Entrenando modelo Transformer con tu historial… esto puede tardar
          unos segundos.
        </p>
      </div>
    );
  }

  if (!data || data.status === "no_data") {
    return (
      <div className="insights-panel">
        <h2 className="insights-title">Predicción avanzada (Transformers)</h2>
        <p className="insights-subtitle">
          {(data && data.message) || "No hay datos suficientes."}
        </p>
      </div>
    );
  }

  const daily = (data.daily_data || []).map((d) => ({
    day: d.day,
    value: d.count,
  }));

  const lastDay = daily.length > 0 ? new Date(daily[daily.length - 1].day) : new Date();
  const future = (data.prediction_next_7_days || []).map((v, i) => {
    const d = new Date(lastDay);
    d.setDate(d.getDate() + i + 1);
    return { day: d.toISOString().slice(0, 10), value: Number(v.toFixed(2)) };
  });
  const combined = [...daily, ...future];
  const splitX = daily.length > 0 ? daily[daily.length - 1].day : null;

  const toolData = (data.tool_embeddings || []).map((t) => ({
    name: t.tool || "—",
    count: t.count,
  }));
  const hourData = (data.hour_embeddings || []).map((h) => ({
    hour: `${String(h.hour).padStart(2, "0")}h`,
    count: h.count,
  }));

  return (
    <div className="insights-panel">
      <h2 className="insights-title">Predicción avanzada (Transformers)</h2>
      <p className="insights-subtitle">
        Modelo Transformer multimodal con embeddings de herramientas y horarios.
      </p>

      <div className="insights-grid">
        <div className="insights-card">
          <h3>Predicción próximos 7 días</h3>
          <p style={{ marginTop: 6, color: "#f3f4f6" }}>
            {(data.prediction_next_7_days || [])
              .map((v) => Number(v).toFixed(1))
              .join(", ")}
          </p>
        </div>

        <div className="insights-card">
          <h3>Herramientas distintas</h3>
          <div className="insights-metric">{toolData.length}</div>
        </div>

        <div className="insights-card">
          <h3>Horas activas</h3>
          <div className="insights-metric">{hourData.length}</div>
        </div>
      </div>

      <div className="insights-card" style={{ marginTop: "20px" }}>
        <h3>Histórico + predicción Transformer</h3>
        <ResponsiveContainer width="100%" height={240}>
          <LineChart data={combined}>
            <XAxis dataKey="day" stroke="#6b7280" />
            <YAxis stroke="#6b7280" />
            <Tooltip />
            {splitX && (
              <ReferenceLine
                x={splitX}
                stroke="#f59e0b"
                strokeDasharray="3 3"
                label={{ value: "Hoy", fill: "#f59e0b", fontSize: 11, position: "top" }}
              />
            )}
            <Line type="monotone" dataKey="value" stroke="#3b82f6" strokeWidth={3} dot={{ r: 3 }} />
          </LineChart>
        </ResponsiveContainer>
      </div>

      {toolData.length > 0 && (
        <div className="insights-card" style={{ marginTop: "20px" }}>
          <h3>Embeddings de herramientas</h3>
          <ResponsiveContainer width="100%" height={220}>
            <BarChart data={toolData}>
              <XAxis dataKey="name" stroke="#6b7280" />
              <YAxis stroke="#6b7280" />
              <Tooltip />
              <Bar dataKey="count" fill="#8b5cf6" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}

      {hourData.length > 0 && (
        <div className="insights-card" style={{ marginTop: "20px" }}>
          <h3>Embeddings por hora del día</h3>
          <ResponsiveContainer width="100%" height={220}>
            <BarChart data={hourData}>
              <XAxis dataKey="hour" stroke="#6b7280" />
              <YAxis stroke="#6b7280" />
              <Tooltip />
              <Bar dataKey="count" fill="#10b981" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
}

const ResumenInsights = Sentry.withErrorBoundary(ResumenInsightsInner, {
  fallback: (
    <div className="insights-panel" data-testid="resumen-insights-error">
      <h2 className="insights-title">Resumen</h2>
      <p className="insights-subtitle">
        Ha ocurrido un error al cargar el resumen. El equipo ya fue notificado.
      </p>
    </div>
  ),
});

export default ResumenInsights;
